import React, { useEffect, useState } from "react";
import "./Footer.css";
import axiosConfig from "../../Service/axiosConfig";
import { NavLink, useNavigate } from "react-router-dom";
import { PiMapPinLight } from "react-icons/pi";
import { FaLocationDot, FaMobileScreen } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTwitter,
} from "react-icons/fa";

const Footer = () => {
  const [stores, setStores] = useState([]);
  const [Data, SetData] = useState([]);
  const [Email, Setemail] = useState({});
  const [error, setError] = useState("");
  const [siteData, setSiteData] = useState({});
  const [policy, setPolicy] = useState({});
  const [brands, setBrands] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);

  const navigate = useNavigate();

  useEffect(() => {
    // 1. Initial cached data from localStorage
    try {
      const cached = JSON.parse(localStorage.getItem("site_data") || "{}");
      if (cached && typeof cached === "object") {
        setSiteData(cached);
      }
    } catch (e) {
      console.warn("Could not parse site_data from localStorage", e);
    }

    // 2. Fetch fresh config from /sitedata/site-config/ (referred from site-exit)
    axiosConfig
      .get("/sitedata/site-config/")
      .then((res) => {
        const data = res.data;
        if (data?.site) {
          setSiteData((prev) => ({
            ...prev,
            ...data.site,
            theme: data.theme || prev.theme,
            tenant: data.tenant || prev.tenant,
          }));
        } else if (data?.results?.[0]) {
          setSiteData((prev) => ({
            ...prev,
            ...data.results[0],
          }));
        }
      })
      .catch((err) => {
        console.warn("site-config failed, trying /sitedata/site/:", err);
        axiosConfig
          .get("/sitedata/site/")
          .then((res) => {
            if (res?.data?.results?.[0]) {
              setSiteData((prev) => ({ ...prev, ...res.data.results[0] }));
            }
          })
          .catch(() => {});
      });

    // 3. Categories, brands, stores
    axiosConfig
      .get("/catlog/categories/?page_size=30&is_suspended=false")
      .then((res) => SetData(res.data.results || []))
      .catch(console.error);

    axiosConfig
      .get(`catlog/brands/?page_size=1000`)
      .then((res) => setBrands(res.data.results || []))
      .catch(console.error);

    axiosConfig
      .get(`/stores/stores/?page=1&page_size=50&is_suspended=false`)
      .then((res) => setStores(res.data.results || []))
      .catch(console.error);
  }, []);

  const GetEmail = async () => {
    try {
      await axiosConfig.post(`/masters/subscribe/`, Email);
      setError("✓ Subscribed successfully!");
    } catch (err) {
      const msg = err.response?.data?.email?.[0];
      setError(
        msg === "Enter a valid email address."
          ? "Invalid email address."
          : msg === "subscribe with this email already exists."
            ? "Already subscribed."
            : "Something went wrong."
      );
    }
  };

  const hasMoreLocations = stores.length > visibleCount;
  const visibleStores = stores.slice(0, visibleCount);

  let copyrightData = null;
  try {
    if (siteData?.copy_right) {
      copyrightData =
        typeof siteData.copy_right === "string"
          ? JSON.parse(siteData.copy_right)
          : siteData.copy_right;
    }
  } catch (e) {
    copyrightData = null;
  }

  const brandTitle =
    copyrightData?.website ||
    siteData?.tenant?.company_name ||
    siteData?.title ||
    siteData?.name ||
    "Our Store";

  const logoUrl =
    siteData?.theme?.logo_url ||
    siteData?.logo?.image ||
    localStorage.getItem("siteLogo") ||
    "";

  // Contact info fields (with site-exit fallbacks)
  const locationAddress =
    siteData?.contact?.address ||
    siteData?.address ||
    "Texas, United States";

  const phoneNumber =
    siteData?.contact?.mobile ||
    siteData?.contact?.phone ||
    siteData?.phone ||
    "408-216-7968";

  const emailAddress =
    siteData?.contact?.email ||
    siteData?.email ||
    "4sridar@gmail.com";

  // Social URLs
  const facebookUrl = siteData?.social?.facebook || siteData?.facebook;
  const instagramUrl = siteData?.social?.instagram || siteData?.instagram;
  const linkedinUrl =
    siteData?.social?.linkedin ||
    siteData?.social?.linkedn ||
    siteData?.linkedin ||
    siteData?.linkedn;
  const youtubeUrl = siteData?.social?.youtube || siteData?.youtube;
  const twitterUrl = siteData?.social?.twitter || siteData?.twitter;
  const hasSocials = Boolean(
    facebookUrl ||
    instagramUrl ||
    linkedinUrl ||
    youtubeUrl ||
    twitterUrl
  );

  return (
    <footer className="footer-container">
      <div
        className="container"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {/* ── Main Grid ── */}
        <div className="footer-main row">
          {/* Col 1 – Brand / About */}
          <div className="col-lg-3 col-md-6 footer-col">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={brandTitle}
                className="footer-logo"
                onClick={() => {
                  navigate("/");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            ) : (
              <h6 className="footer-heading">{brandTitle}</h6>
            )}
            <p className="footer-about">
              {siteData?.description ||
                "Your trusted destination for quality products and equipment. Shop with confidence."}
            </p>
          </div>

          {/* Col 2 – Useful Links */}
          <div className="col-lg-2 col-md-6 footer-col">
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-list">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/contactus">Contact Us</NavLink>
              </li>
              <li>
                <NavLink to="/blogs">Blogs</NavLink>
              </li>
              {brands.length > 0 && (
                <li>
                  <NavLink to="/brands">Brands</NavLink>
                </li>
              )}
              <li>
                <NavLink to="/privacy">Privacy Policy</NavLink>
              </li>
              <li>
                <NavLink to="/terms-of-service">Terms of Service</NavLink>
              </li>
              {policy?.faq && (
                <li>
                  <NavLink to="/faqs">FAQs</NavLink>
                </li>
              )}
              {policy?.return_policy && (
                <li>
                  <NavLink to="/return-policy">Return Policy</NavLink>
                </li>
              )}
              {policy?.cancellation && (
                <li>
                  <NavLink to="/cancellation">Cancellation</NavLink>
                </li>
              )}
            </ul>
          </div>

          {/* Col 3 – Categories */}
          <div className="col-lg-3 col-md-6 footer-col">
            <h6 className="footer-heading">Categories</h6>
            <ul className="footer-list footer-cat-grid">
              {Data.map((cat) => (
                <li key={cat.id}>
                  <NavLink to={`/${cat.slug}`}>{cat.name}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 – Get In Touch & Social (Referred from site-exit) */}
          <div className="col-lg-4 col-md-6 footer-col">
            <h6 className="footer-heading">Get In Touch</h6>

            <div className="footer-contact-card">
              <div className="contact-icon">
                <FaLocationDot />
              </div>
              <div>
                <span>Location</span>
                <p>{locationAddress}</p>
              </div>
            </div>

            <div className="footer-contact-card">
              <div className="contact-icon">
                <FaMobileScreen />
              </div>
              <div>
                <span>Phone Number</span>
                <p>
                  <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                </p>
              </div>
            </div>

            <div className="footer-contact-card">
              <div className="contact-icon">
                <IoIosMail />
              </div>
              <div>
                <span>Email Address</span>
                <p className="footer-email">
                  <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </p>
              </div>
            </div>

            {/* Social Icons */}
            {hasSocials && (
              <div className="footer-socials">
                {facebookUrl && (
                  <a
                    href={facebookUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                )}

                {instagramUrl && (
                  <a
                    href={instagramUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                )}

                {linkedinUrl && (
                  <a
                    href={linkedinUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                )}

                {youtubeUrl && (
                  <a
                    href={youtubeUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="YouTube"
                  >
                    <FaYoutube />
                  </a>
                )}

                {twitterUrl && (
                  <a
                    href={twitterUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Twitter"
                  >
                    <FaTwitter />
                  </a>
                )}
              </div>
            )}

            {/* App Download */}
            {siteData?.android_link && (
              <NavLink
                className="download-app-link"
                target="_blank"
                to={siteData.android_link}
              >
                Download App&nbsp;
                <img src={require("./images/android.webp")} alt="Android" />
              </NavLink>
            )}
          </div>
        </div>

        {/* ── Locations ── */}
        {siteData?.ecommerce_type !== "Conventional" && stores.length > 0 && (
          <div className="footer-locations">
            <h6 className="footer-heading">Our Locations</h6>
            <div className="locations-grid">
              {visibleStores.map((loc, i) => (
                <span key={i} className="location-item">
                  <PiMapPinLight size={14} style={{ marginRight: 4 }} />
                  {loc.store_location}
                </span>
              ))}
            </div>
            {hasMoreLocations && (
              <button
                className="see-more-btn"
                onClick={() => setVisibleCount((c) => c + 6)}
              >
                See More
              </button>
            )}
          </div>
        )}
      </div>

      {/* ── Bottom Bar ── */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-inner container">
          <p className="copyright">
            © {new Date().getFullYear()} {brandTitle}. All Rights Reserved.
          </p>

          <div className="footer-legal-links">
            <span
              onClick={() => {
                navigate("/privacy");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Privacy Policy
            </span>
            <span className="legal-divider">|</span>
            <span
              onClick={() => {
                navigate("/terms-services");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Terms of Service
            </span>
          </div>

          {siteData?.maintained_by && (
            <p className="powered-by">
              Developed &amp; Maintained by{" "}
              <a
                href={`https://${siteData.maintained_by}`}
                target="_blank"
                rel="noreferrer"
              >
                {siteData.maintained_by}
              </a>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
};

export { Footer };
